import { SignIn } from '@clerk/react';
import { Logo } from '@/components/Logo';
import { edgemailClerkTheme } from '@/lib/clerk-theme';

export function SignInPage() {
  return (
    <div className="min-h-screen grid lg:grid-cols-[1fr_1.3fr] bg-white">
      {/* --------------------- Left Form Column --------------------- */}
      <div className="flex flex-col p-8 lg:p-16 relative overflow-y-auto z-10 w-full max-w-2xl mx-auto">
        <div className="mb-auto">
          <Logo variant="full" size={44} />
        </div>

        {/* Flush Center Form */}
        <div className="w-full max-w-[380px] mx-auto py-12">
          <SignIn
            routing="path"
            path="/sign-in"
            signUpUrl="/sign-up"
            fallbackRedirectUrl="/app/inbox"
          />
        </div>
        
        <div className="mt-auto text-xs text-muted-foreground/50">
          © {new Date().getFullYear()} EdgeMail.
        </div>
      </div>

      {/* --------------------- Right Hero Column (Windsurf Style) --------------------- */}
      <div className="hidden lg:flex flex-col relative overflow-hidden bg-[#eff6fc] border-l border-border/40">
        
        {/* Dynamic diagonal CSS grid/fade background matching Windsurf */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
          <div className="absolute top-[-20%] left-[-10%] w-[150%] h-[150%] transform -rotate-[15deg]">
            <div className="w-full h-[80px] bg-gradient-to-r from-transparent via-white/40 to-transparent mt-[15%]" />
            <div className="w-full h-[180px] bg-gradient-to-r from-transparent via-white/50 to-transparent mt-[15%]" />
            <div className="w-full h-[2px] bg-gradient-to-r from-transparent via-[#4ade80]/20 to-transparent mt-[10%]" />
          </div>
        </div>

        {/* Massive hero image bleeding off the right side with no constraints */}
        <div 
          className="absolute top-[12%] left-[8%] right-[-15%] z-10 bottom-0 pointer-events-none"
          style={{
            WebkitMaskImage: 'linear-gradient(to bottom, black 55%, transparent 95%)',
            maskImage: 'linear-gradient(to bottom, black 55%, transparent 95%)'
          }}
        >
          <img 
            src="/sign-in-screenshot.jpg" 
            alt="EdgeMail Agent in action" 
            className="w-full h-[95%] object-cover object-left-top rounded-tl-xl shadow-[-20px_20px_80px_-15px_rgba(0,0,0,0.15)] border-t border-l border-white/60 bg-white" 
          />
        </div>

        {/* Floating Testimonial/Hero Quote overlay */}
        <div className="absolute bottom-[8%] left-[8%] right-[20%] z-20">
           <div className="bg-white/80 backdrop-blur-[12px] p-6 lg:p-8 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-white max-w-2xl">
             <p className="text-foreground/80 font-medium leading-relaxed text-lg tracking-tight">
               "Every single one of these agents acts literally like spending a whole day configuring email tools with superpowers, effectively strapping rocket boosters to our customer communication."
             </p>
             <div className="flex items-center gap-3 mt-6">
               <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center text-accent font-semibold tracking-tight">FK</div>
               <div>
                 <div className="text-sm font-semibold text-foreground">Francis K.</div>
                 <div className="text-xs text-foreground/60 flex items-center gap-1">
                    <span className="w-4 h-4 rounded-[3px] bg-[#f26522] flex items-center justify-center text-white text-[9px] font-bold">Y</span> 
                    Combinator
                 </div>
               </div>
             </div>
           </div>
        </div>

      </div>
    </div>
  );
}
